var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.share()}}},[(_vm.hasSlot())?_vm._t("clickable"):_c('p',[_vm._v("Share")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }